import { createSelector } from 'reselect';

// Models
import { BlacklistActionTypes } from 'app/modules/lists/models';

export const selectBlacklists = (state: RootState) =>
  state.blacklists.blacklists || [];

export const selectActiveBlacklists = createSelector(
  selectBlacklists,
  (blacklists) => blacklists.filter(({ status }) => status === 'ACTIVE'),
);

export const selectBlacklistsLoading = (state: RootState) =>
  Boolean(state.loading[BlacklistActionTypes.RETRIEVE_BLACKLISTS]);

export const selectBlacklistsCount = (state: RootState) =>
  state.blacklists.blacklistsCount || 0;

export const selectCreateBlacklistLoading = (state: RootState) =>
  Boolean(state.loading[BlacklistActionTypes.CREATE_BLACKLIST]);
